import React, { useState } from "react";

interface CustomMailProps {
    className?: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder?: string;
}

const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

const CustomMail: React.FC<CustomMailProps> = ({ className, value, onChange, placeholder }) => {
    const [touched, setTouched] = useState(false);
    const isValid = value === "" || emailRegex.test(value);

    return (
        <>
            <input
                type="email"
                className={`form-control ${className || ""}`}
                value={value}
                onChange={onChange}
                onBlur={() => setTouched(true)}
                placeholder={placeholder}
                autoComplete="email"
            />
            {!isValid && touched && (
                <div className="text-danger" style={{ fontSize: 12 }}>
                    Please enter a valid email address.
                </div>
            )}
        </>
    );
};

export default CustomMail;
